export default __webpack_public_path__ + "static/media/gallery7.53f9087a.jpg";